  
// function openNav() {
//     $('#mySidenav').css({'width':'250px'});
// }

// function closeNav() {
//     $('#mySidenav').css({'width':'0'});
// }

$(document).on('click','.panel.panel-default a',function(){
    let spanContent = $(this).find('span').text()
    $(this).find('span').text((spanContent == ' + ') ? ' - ' : ' + ')
})

$(document).on('click','.humberger-menu',function(){
    $('#mySidenav').css({'width':'250px'});
});

$(document).on('click','.closebtn',function(){
    $('#mySidenav').css({'width':'0'});
});
$(document).ready(function() {
   
    $('.search-container.input-group input').addClass('form-control mr-sm-2');
    $('.dgwt-wcas-search-submit').addClass('fa fa-search');
    $('.dgwt-wcas-search-submit').html('<i class="fa fa-search"></i>');

    $(document).on('mouseenter','.categ-focused',function(){
        // Change src attribute of image
        const imageURL = $(this).data('image');
        $('.image-categ').attr('src', imageURL);
    });   
 
    $(document).on('click','.catogary', function(){
        var href = $(this).attr('href');
        location.href = href;
    });

    $(document).on('click','.menu-panier .submenu a, .link-btn-compte', function(){
        var href = $(this).attr('href');
        location.href = href;
    });

    /***********    Top header menu     **********/

    [].slice.call(document.querySelectorAll('.dropdown .top-header-menu-item')).forEach(function(el){
        el.addEventListener('mouseenter', onClick, false);
    });

    [].slice.call(document.querySelectorAll('.dropdown .top-header-menu-item')).forEach(function(el){
        el.addEventListener('click', onClick, false);
    });

    // [].slice.call(document.querySelectorAll('.dropdown .nav-link')).forEach(function(el){
    //     el.addEventListener('mouseleave', onClick, false);
    // });
  
    function onClick(e){
        e.preventDefault();
        var el = this.parentNode;
        el.classList.contains('show-submenu') ? hideSubMenu(el) : showSubMenu(el);
    }
    
    function showSubMenu(el){
        el.classList.add('show-submenu');
        document.addEventListener('click', function onDocClick(e){
            e.preventDefault();
            if(el.contains(e.target)){
                return;
            }
            document.removeEventListener('click', onDocClick);
            hideSubMenu(el);
        });
    }
    
    function hideSubMenu(el){
        el.classList.remove('show-submenu');
    }
    /********    Fin  top header menu    ********/

    $(window).resize(function(){
    if ($(window).width() >= 980){
    
    $('.navbar .dropdown-toggle').hover(function () {
    $(this).parent().toggleClass('show');
    $(this).parent().find('.dropdown-menu').toggleClass('show');
    });
    
    $( '.navbar .dropdown-menu' ).mouseleave(function() {
    $(this).removeClass('show');
    });
    
    }
    });    

});

    


// WEBPACK FOOTER //
// ./scripts/script.js